/**
 * Facet Search.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import toggleOverlay from '../actions/toggleOverlay';
import checkScreenSize from '../actions/checkScreenSize';
import Teaser from '../components/Teaser';
import Facets from '../components/Facets';
import Loader from '../components/Loader';
import Pagination from '../components/Pagination';
import ActiveFilters from '../components/ActiveFilters';

import {
	showFacetFilters,
} from '../reducers';

import getSearchUrl from '../actions/getSearchUrl';
import fetchFilters from '../actions/fetchFilters';

class FacetSearch extends Component {

	constructor ( props ) {
		super();
	}

	componentDidMount() {

		/**
		 * Filters dienen eerst ingeladen te worden, anders kunnen URL parameters niet gematcht worden om actieve data op te halen
		 */
		this.props.dispatch( fetchFilters() );

		/**
		 * Check screen size om te kijken of je op mobiel of desktop zit.
		 */

		this.props.dispatch( checkScreenSize() );
	}

	render() {

		const {
			filteredTeasers,
			pending,
			activeCategoriesObj,
			totalResults,
			facetFilters,
			pageIntro,
		} = this.props.state;

		const toggleFacetFilters = ( e ) => {
			this.props.dispatch( showFacetFilters( true ) );
			toggleOverlay( true );
		}

		return (
			<div className='grid grid-12-l has-s-top-margin'>
				<div className={ 'facets js-facets grid__unit--pos-1x1-l grid__unit--size-1x4-l grid__unit--size-1x3-xl' + ( facetFilters ? ' open' : '' ) }>
					<Facets />
				</div>
				<div className="filtered-results grid__unit--pos-1x5-l grid__unit--size-1x8-l grid__unit--pos-1x4-xl grid__unit--size-1x9-xl">
					{ pending ?
						<Loader /> :
						<>
							<div className="intro">
								<div className="intro__content">
									<div className="intro__header">
										<ol className="intro__breadcrumbs breadcrumbs">
											<li className="breadcrumb">
												<a href="/lerarenkaart/" className="breadcrumb__link">Lerarenkaart</a>
											</li>
											<li className="breadcrumb">
												<a href="/lerarenkaart/alle-voordelen/" className="breadcrumb__link">Alle voordelen</a>
											</li>
											{ activeCategoriesObj && activeCategoriesObj.activeSubcategoryLabel &&
												<li className="breadcrumb">
													{ activeCategoriesObj.activeCategoryLabel }
												</li>
											}
										</ol>
										<div className="intro__title title">
											<h1 className="title__text has-xxl-title-size">
												<span>
													{ activeCategoriesObj.activeCategoryLabel || activeCategoriesObj.activeSubcategoryLabel ?
														activeCategoriesObj.activeCategoryLabel && activeCategoriesObj.activeSubcategoryLabel ? activeCategoriesObj.activeSubcategoryLabel : activeCategoriesObj.activeCategoryLabel
														: 'Alle voordelen' }
												</span>
											</h1>
										</div>
										{ pageIntro &&
											<p className="intro__text has-xs-top-margin">
												{ pageIntro }
											</p>
										}
									</div>
								</div>
							</div>
							{ !facetFilters &&
								<div className="facets__toggle has-s-top-margin">
									<button className="button is-style-primary" onClick={ toggleFacetFilters }>
										{ '' !== totalResults &&
											<>
												<span className="icon icon--filter icon-size--s icon-space--after"></span>Filter { 1 === totalResults ? totalResults + ' voordeel' : totalResults + ' voordelen' }
											</>
										}
									</button>
								</div>
							}
							<ActiveFilters />
							{ '' !== totalResults &&
								<div className="filtered-results__amount has-xs-top-margin" aria-live="polite" aria-atomic="true">
									<span className="is-weight-bold">{ 1 === totalResults ? totalResults + ' resultaat' : totalResults + ' resultaten' }</span> gevonden
								</div>
							}
							{
								filteredTeasers && filteredTeasers.length > 0 &&
								<div className="filtered-results__results grid grid-2-s grid-3-xl has-s-top-margin">
									{ filteredTeasers.map( ( teaser ) =>
										<Teaser teaser={ teaser } />
									)
									}
								</div>
							}
							<Pagination />
						</>
					}
				</div>
			</div>
		);
	}
}

function mapStateToProps( state ) {
	return { state };
}

export default connect( mapStateToProps )( FacetSearch );
